import api from "./api";
import { generateErrorMessage } from "../utils/message";


/*Dashboards*/
export const registerDashboard = async (dashboardData) => {
  try {
    const response = await api.post("/ews", dashboardData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "dashboard");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

// Column keys GET /ews accepts as filters. Anything else is ignored by the
// backend DTO, so the list is kept in sync with it here rather than forwarding
// the whole filter map blindly.
const EWS_FILTER_KEYS = [
  "vendor_code",
  "vendor_name",
  "commodity",
  "inventory_last_update",
  "judge_stock",
  "judge_4m",
];

export const fetchDashboardsFromAPI = async (
  page = 1,
  perPage = 10,
  search = "",
  columnFilters = {},
  sort = {},
) => {
  try {
    // `search` is the filter-bar object ({ vendorCode, period, feedback }),
    // spread as-is the way this endpoint has always received it.
    const params = { page, per_page: perPage, ...(search || {}) };

    EWS_FILTER_KEYS.forEach((key) => {
      const value = columnFilters?.[key];
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        params[key] = value;
      }
    });

    if (sort && sort.sortBy) {
      params.sort_by = sort.sortBy;
      params.sort_dir = sort.sortDir === "desc" ? "desc" : "asc";
    }

    const response = await api.get("/ews", { params });

    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "dashboard");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const deleteDashboardsFromAPI = async (dashboardId) => {
  try {
    const response = await api.delete(`/ews/${dashboardId}`, {
      params: { dashboard_id: dashboardId },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "dashboard");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const fetchDashboardsById = async (dashboardId) => {
  try {
    const response = await api.get(`/ews/${dashboardId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data dashboard", "dashboard");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateDashboard = async (id, dashboardData) => {
  try {
    const response = await api.put(`/ews/${id}`, dashboardData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "dashboard");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const uploadDashboardFileToAPI = async (formData) => {
  try {
    const response = await api.post("/inventories/submit-excel-dashboard", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("upload dashboard file", "dashboard");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const downloadDashboardFileFromAPI = async (fileType, vendorCode, dashboardMonth) => {
  try {
    // Convert dashboardMonth from "YYYY-MM" to "YYYYMM"
    const formattedDashboardMonth = dashboardMonth.replace("-", "");

    const response = await api.post(`/inventories/download/${fileType}/${vendorCode}/${formattedDashboardMonth}`);

    if (response.data?.data?.filePath) {
      const fileUrl = response.data.data.filePath;
      
      // Open the file URL in a new tab for user download
      window.open(fileUrl, "_blank");
    } else {
      throw new Error("File URL not found in response.");
    }
  } catch (error) {
    const fallback = generateErrorMessage("download dashboard file", "dashboard");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};
